type ToastEvent = { message: string; color?: string; duration?: number };
type Listener = (event: ToastEvent) => void;

const listeners = new Set<Listener>();

export function showToast(message: string, color: string = "danger", duration: number = 3000) {
  const event: ToastEvent = { message, color, duration };
  listeners.forEach((fn) => fn(event));
}

export function onToast(callback: Listener): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
